import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = (parentReducer, assignmentKey) => {
    const reducer_key = assignmentKey;
    return new (class {
        selectFiles = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer[reducer_key];
            return reducer.files;
        };
        selectFolders = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer[reducer_key];
            return reducer.folders;
        };
        selectFileType = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer[reducer_key];
            return reducer.fileType;
        };
        selectJobPackFiles = createSelector(
            [this.selectFiles, this.selectFileType],
            (files = false, fileType = "") => {
                let arr = [];
                let fileObj = {};
                if (files) {
                    // let jobPackFiles = _.compact(
                        // Object.keys(files).map(e => {
                        //     if (fileType !== "") {
                        //         let type =
                        //             _.get(files[e], "file_folder") ||
                        //             "job_pack_files";
                        //         if (type === fileType) {
                        //             return files[e];
                        //         } else {
                        //             return null;
                        //         }
                        //     } else {
                        //         return files[e];
                        //     }
                        // })
                       Object.keys(files).map(e => {
                            Object.values(files[e]).map(f => {
                                fileObj = {}
                                if(fileType !== ""){
                                    let type = f.file_folder || "job_pack_files";
                                    if(type === fileType){
                                        fileObj['file_id'] = f.file_id
                                        fileObj['file_name'] = f.file_name
                                        fileObj['date_added'] = f.date_added
                                         fileObj['file_size'] = f.file_size
                                        fileObj['file_folder'] = f.file_folder
                                        fileObj['file_url'] = f.file_url
                                        fileObj['file_type'] = f.file_type
                                        fileObj['file_directory'] = f.file_directory
                                        arr.push(fileObj)
                                     return null;
                                    }else {
                                        return null;
                                    }
                                }else {
                                    fileObj['file_id'] = f.file_id
                                        fileObj['file_name'] = f.file_name
                                        fileObj['date_added'] = f.date_added
                                         fileObj['file_size'] = f.file_size
                                        fileObj['file_folder'] = f.file_folder
                                        fileObj['file_url'] = f.file_url
                                        fileObj['file_type'] = f.file_type
                                        fileObj['file_directory'] = f.file_directory
                                        arr.push(fileObj)
                                        return null;
                                }
                            })
                            return null
                        })
                    return _.orderBy(arr, "file_name");
                } else {
                    return false;
                }
            }
        );
    })();
};
export default createSelectors;
